import React from "react";
import {
    Page,
    Text,
    View,
    Document,
    StyleSheet,
    Image
} from "@react-pdf/renderer";

const styles = StyleSheet.create({
    page: {
    backgroundColor: '#ffffff'
    },
    section: {
    margin: 20,
    padding: 10,
    flexGrow: 1
    },
    company_name: {
        Font:'Arial',
        fontWeight:500,
        fontSize:9
    },
    computationsText: {
        Font:'Arial',
        fontWeight:900,
        fontSize:10
    },

    package: {
        Font:'Arial',
        fontWeight:900,
        fontSize:9,
        width:100
    },
    company_adress: {
        Font:'Arial',
        fontWeight:700,
        fontSize:9
    },
    padding:{
        padding:1
    },
    paddingTop10:{
        paddingTop:13
    },
    cell: {
        marginRight:10,

    },
    cellRight: {
        textAlign:"right"
   
    },
    cellLeft: {
        textAlign:"left"
       
    },
    tableRow:{
        display: 'flex',
        flexDirection: 'row',

    },
    col1:{
        display: 'flex',
        flexDirection: 'row',
        width:150
    },

    paymentInfoText:{
        Font:'Roboto',
        fontWeight:500,
        fontSize:10
    },

    paymentInfoCol:{
        display:'flex',
        flexDirection:'row',
        width:70
    },

    rowWidth:{
        width:'100%'
    },
    col50:{
        width:'50%'
    },
    col45:{
        width:'45%'
    },
    col2:{
        display: 'flex',
        flexDirection: 'row',
        width:100
    },
    col3:{
        display: 'flex',
        flexDirection: 'row',
        width:100
    },
    col4:{
        display: 'flex',
        flexDirection: 'row',
        width:100
    },
    col5:{
        display: 'flex',
        flexDirection: 'row',
        width:100
    },
    floatright:{
        alignItems:"flex-end"
    },
    colComputations1:{
        width:100
    },
    colComputations2:{
        width:100
    },
    row:{
        display: 'flex',
        flexDirection: 'row',
    },
    textcenter:{
        textAlign:"center"
    },
    textleft:{
        textAlign:"left"
    },
    textRight:{
        textAlign:"right"
    },
    border:{
        borderBottom:1,
    },
    borderAll:{
        border:1
    },
    borderTop:{
        borderTop:1,
    },
    boldFont:{
        fontWeight:980,
    },
    fontSize11:{
        fontSize:11,
        fontWeight:800,
    },
    textCenter:{
        alignItems:'center'
    },
    alignCenter:{
        display: 'flex',
        flexDirection: 'row',
    },
    marginRight10:{
        marginRight:'10%'
    },
    paddingLeft:{
        paddingLeft:450
    },
    marginTopt10:{
        paddingTop:'10%'
    },
    pageNumbers: {
        position: 'absolute',
        bottom: 20,
        left: 0,
        right: 0,
        textAlign: 'center',
        fontSize:6
    },
});

export function PdfDocument(props) {
    // console.log(props.headers);
    return (
        <Document>
            <Page size="Letter" style={styles.page} orientation="portrait" wrap>


                    <View style={styles.section}>
                        {/* HEADER SECTION DUBAI */}
                               
                        <View style={styles.textCenter}>
                                <Text style={styles.fontSize11}>Inventory Consumption Report</Text>
                            </View>
                            <View style={styles.paddingTop10}>
                            </View>
                            <Text style={[styles.company_name,styles.rowWidth,styles.paddingTop10,styles.padding]}>Date Range:  {props.headers.fromdate} {props.headers.todate}</Text>
                            <Text style={[styles.company_name,styles.rowWidth,styles.padding]}>Generated By:  {props.headers.username}</Text>
                            <Text style={[styles.company_name,styles.rowWidth,styles.padding]}>Date:  {props.headers.printed_date}</Text>


                        {/* HEADER SECTION */}

                        {/* Item Details */}
                        <View style={[styles.tableRow,styles.paddingTop10,styles.border]}>
                            <View style={[styles.tableRow,styles.col1,styles.cellLeft]}>
                                <Text style={[styles.company_adress,styles.cellLeft,styles.boldFont]}>Inventory</Text>
                            </View>
                            <View style={[styles.tableRow,styles.col3,styles.cellRight]}>
                                <Text style={[styles.company_adress,styles.cellRight,styles.boldFont]}>Unit</Text>
                            </View>
                            <View style={[styles.tableRow,styles.col4,styles.cellRight]}>
                                <Text style={[styles.company_adress,styles.cellRight,styles.boldFont]}>Location</Text>
                            </View>
                            <View style={[styles.tableRow,styles.col5,styles.cellRight]}>
                                <Text style={[styles.company_adress,styles.cellRight,styles.boldFont]}>Released</Text>
                            </View>
                            <View style={[styles.tableRow,styles.col5,styles.cellRight]}>
                                <Text style={[styles.company_adress,styles.cellRight,styles.boldFont]}>Total</Text>
                            </View>
                        </View>
                        {!props.items == "" ? 
                            props.items.map((row, ind) => 
                                <View style={[styles.tableRow,styles.border]}>
                                    <View style={[styles.tableRow,styles.col1]}>
                                        <Text style={[styles.company_adress,styles.cellLeft,styles.padding]}>{props.items[ind].description}</Text>
                                    </View>
                                    <View style={[styles.tableRow,styles.col3]}>
                                    <Text style={[styles.company_adress,styles.cellRight,styles.padding]}>{props.items[ind].unit}</Text>
                                    </View>
                                    <View style={[styles.tableRow,styles.col4]}>
                                        <Text style={[styles.company_adress,styles.cellRight,styles.padding]}>{props.items[ind].location}</Text>
                                    </View>
                                    <View style={[styles.tableRow,styles.col5]}>
                                        <Text style={[styles.company_adress,styles.cellRight,styles.padding]}>{props.items[ind].released}</Text>
                                    </View>
                                    <View style={[styles.tableRow,styles.col5]}>
                                        <Text style={[styles.company_adress,styles.cellRight,styles.padding]}>{props.items[ind].total}</Text>
                                    </View>
                                </View>
                            )
                        : null} 

 


                        <Text style={styles.pageNumbers} render={({ pageNumber, totalPages }) => (
                            `Page ${pageNumber} | ${props.headers.printed_date}`
                        )} />
                    </View>
      
            </Page>
        </Document>
    );
};